import React, { useMemo } from "react";
import PageScaffold from "../../components/PageScaffold";
import { Box } from "@chakra-ui/react";
import { useUserDetailsContext } from "../../context/userDetailsContext";

const RETOOL_BASE_URL = "https://garaaz.retool.com/apps/QC_DASHBOARD";

const QCDashboard = () => {
  const { _id } = useUserDetailsContext();
  const iframeSrc = useMemo(
    () =>
      _id
        ? `${RETOOL_BASE_URL}?mongoUserId=${encodeURIComponent(_id)}`
        : null,
    [_id]
  );

  return (
    <PageScaffold title="QC Dashboard" isHeaderVisible={true}>
      <Box height="calc(100vh - 64px)" width="100%">
        {iframeSrc && (
          <iframe
            src={iframeSrc}
            width="100%"
            height="100%"
            style={{ border: "none" }}
            title="QC Dashboard"
          />
        )}
      </Box>
    </PageScaffold>
  );
};

export default QCDashboard;
